// removed by extract-text-webpack-plugin
module.exports = {"root":"route-sign-form--root--1EWzKzME","error":"route-sign-form--error--2Lj1VZDP","box":"route-sign-form--box--14a9kr2A","title":"route-sign-form--title--2sUyiEVZ","route-sings":"route-sign-form--route-sings--cQ1NCJ95","routeSings":"route-sign-form--route-sings--cQ1NCJ95","design-box":"route-sign-form--design-box--1si9PHL6","designBox":"route-sign-form--design-box--1si9PHL6","delete":"route-sign-form--delete--38zKTrOO"};


//////////////////
// WEBPACK FOOTER
// ./views/order-detail/route-sign-form/styles.css
// module id = ./views/order-detail/route-sign-form/styles.css
// module chunks = 0